//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        currencyIdList: [],
      },
    };
  },

  computed: {
    ...mapState('currencies', ['currencies']),
    ...mapState('statisticsSystemStatusCurrencies', ['filterLists']),
    ...mapGetters('statisticsSystemStatusCurrencies', ['currencyTypeList']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('statisticsSystemStatusCurrencies', ['setFilters']),
  },
};
